import { apiGet, apiPost, apiPut, apiDelete } from '../lib/api'

export const COMPANIES_LOAD_SUCCESS = 'COMPANIES_LOAD_SUCCESS'
export const COMPANIES_ALL_LOAD_SUCCESS = 'COMPANIES_ALL_LOAD_SUCCESS'
export const COMPANY_CREATE_SUCCESS = 'COMPANY_ADD_SUCCESS'
export const COMPANY_LOAD_SUCCESS = 'COMPANY_LOAD_SUCCESS'
export const COMPANY_UPDATE_SUCESS = 'COMPANY_UPDATE_SUCESS'
export const COMPANY_DELETE_SUCCESS = 'COMPANY_DELETE_SUCCESS'

export const CLEAR_COMPANIES = 'CLEAR_COMPANIES'
export const CLEAR_COMPANY = 'CLEAR_COMPANY'

export const loadCompanies = (query) => ({ getState, fetch }) => ({
  type: 'COMPANIES_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'companies',
    getState,
    query,
  }),
})

export const loadAllCompanies = (query) => ({ getState, fetch }) => ({
  type: 'COMPANIES_ALL_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'companies/all',
    getState,
    query,
  }),
})

export const loadCompany = (id) => ({ getState, fetch }) => ({
  type: 'COMPANY_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `companies/${id}`,
    getState,
  }),
})

export const createCompany = (body) => ({ getState, fetch }) => ({
  type: 'COMPANY_CREATE',
  payload: apiPost({
    fetch,
    endpoint: 'companies',
    getState,
    body,
  }),
})

export const updateCompany = (body) => ({ getState, fetch }) => ({
  type: 'COMPANY_UPDATE',
  payload: apiPut({
    fetch,
    endpoint: `companies/${body._id}`,
    getState,
    body,
  }),
})

export const deleteCompany = (id) => ({ getState, fetch }) => ({
  type: 'COMPANY_DELETE',
  payload: apiDelete({
    fetch,
    endpoint: `companies/${id}`,
    getState,
  }),
})

export const clearCompanies = () => ({
  type: 'CLEAR_COMPANIES',
  payload: {},
})

export const clearCompany = () => ({
  type: 'CLEAR_COMPANY',
  payload: {},
})

export const getCompaniesCSV = (query) => ({ getState, fetch }) => ({
  type: 'DOWNLOAD_COMPANIES_CSV',
  payload: apiGet({
    fetch,
    endpoint: 'companies/csv',
    getState,
    query,
  }),
})



// WEBPACK FOOTER //
// ./src/common/companies/actions.js